<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">选择科室收支</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 400px;">

        <div style="padding-left: 20px;">
          <el-select v-model="departmentCode" size="mini" @change="departmentChange" placeholder="请选择科室" style="margin-right: 5px">
            <el-option
                v-for="item in department_arr"
                :key="item.departmentCode"
                :label="item.name"
                :value="item.departmentCode">
            </el-option>
          </el-select>
        </div>

        <div style="padding: 20px;">
          <el-checkbox-group v-model="itemCodeList" style="width:100%;">
            <el-checkbox v-for="itemItem in tableData"
                         :label="itemItem.id"
                         :key="itemItem.id"
                         style="width:95%;padding-left: 10px;line-height: 20px">
              {{itemItem.name}}
            </el-checkbox>
          </el-checkbox-group>
        </div>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      tableData:[],

      itemCodeList:[],

      departmentCode: '',
      department_arr:[],

    }
  },
  methods: {
    init(){

      this.itemCodeList = [];

      this.getDepartment();


    },
    closeSelf() {
      this.loading= false
      this.$emit("closeMe");
    },


    getDepartment(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Department/GovAdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          status:1,
        }

      }).then( (response)=> {
        if(response.data.error == 0){
          this.department_arr = response.data.data.list;
          if(this.department_arr.length>0){
            this.departmentCode = this.department_arr[0].departmentCode;
            this.getAdmList();
          }
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },
    departmentChange(val){
      this.departmentCode = val;
      this.getAdmList();
    },

    getAdmList(){
      let that = this;

      that.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentInOut/GovAdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          departmentCode:this.departmentCode,
          type:'',
        }
      }).then( (response)=> {
        //console.log(response);
        that.loading = false;

        if(response.data.error == 0){
          this.tableData = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        that.loading = false;
        console.log(error);
      });
    },

    confirm(){

      console.log(this.itemCodeList);


      if(this.itemCodeList.length==0){
        this.$message("请选择科室收支");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentInOut/GovCopy',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          arr: this.itemCodeList,
        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeMe");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

